import { render } from "./OrderStockFlowForm.vue?vue&type=template&id=22af0e35"
import script from "./OrderStockFlowForm.vue?vue&type=script&lang=js"
export * from "./OrderStockFlowForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__